/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/enforces-negative-arbitrary-values */
/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable react/display-name */
'use client';

// @TODO: We should move validation and mask logic to the shared component

import React, {
  ForwardedRef,
  InputHTMLAttributes,
  forwardRef,
  useState,
} from 'react';
import { Title5 } from '../../tokens/typography/StyledText';
import { Icon } from '../icon';
import { Label } from '../label/Label';
import { cn } from '@ui/lib';

export interface InputProps extends InputHTMLAttributes<Element> {
  id: string;
  name?: string;
  label?: string;
  labelIcon?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  info?: string;
  className?: string;
  error?: string;
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
}

export const TextFieldBasic = forwardRef(
  (
    {
      id,
      name,
      label,
      labelIcon,
      placeholder,
      required,
      info,
      className,
      error,
      leadingIcon,
      trailingIcon,
      type,
      value,
      ...props
    }: InputProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <div className={cn('flex w-full flex-col gap-sm', className)}>
        {label && (
          <Label className="mb-none inline-flex w-full gap-x-xs" forId={id}>
            <Title5 className="text-on-screen-surface">{label}</Title5>
            <div className="size-sm">{labelIcon}</div>
          </Label>
        )}
        
        <div
          className={cn(
            'inline-flex w-full items-center rounded-button-shape border-xxs border-line bg-primary-surface p-md',
            {
              'focus-within:border-tertiary border': !error,
              'border-negative-strong border': error && error !== '',
            },
          )}
        >
          {leadingIcon && (
            <div className="size-md inline-flex items-stretch">
              {leadingIcon}
            </div>
          )}

          <input
            id={id}
            name={name}
            className={cn(
              'typography-body-2 block h-lg w-full text-on-screen-surface outline-none placeholder:text-on-screen-surface-subdued placeholder:text-opacity-pressed ',
              {
                'arrow-hide': type === 'number',
                'pl-md': leadingIcon,
                'pr-md': trailingIcon || type === 'password',
              },
            )}
            placeholder={placeholder}
            required={required}
            ref={ref}
            type={showPassword ? 'text' : type}
            value={value}
            {...props}
          />

          {type === 'password' && !trailingIcon && (
            <button
              type="button"
              className="size-[20px] outline-teal-400 ring-tertiary"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <Icon fileName="ic_eye_show" className="size-[20px]" />
              ) : (
                <Icon fileName="ic_eye_hide" className="size-[20px]" />
              )}
            </button>
          )}

          {trailingIcon && type !== 'password' && (
            <div className="size-md inline-flex items-stretch text-primary">
              {trailingIcon}
            </div>
          )}
        </div>

        {info && !error && (
          <div className="typography-body-caption mt-sm px-card-padding text-on-screen-surface-subdued">
            {info}
          </div>
        )}

        {error && (
          <div className="flex flex-row items-center justify-start gap-x-[6px] px-md">
            <Icon
              fileName="ic_error_circle_filled"
              className="size-md text-negative-strong"
            />
            <div className="typography-body-caption text-negative-strong">
              {error}
            </div>
          </div>
        )}
      </div>
    );
  },
);

// @deprecated Use TextFieldBasic instead
export { TextFieldBasic as Input };
